const TextInput = ({entity, name, size="40", changeHandler, valueGetter=null, indentAttr=null}) => {

    const changeHandlerWrapper = (event) => {
        const {value} = event.target
        changeHandler(entity.id, name, value)
    }

    return (
        <input
            type="text"
            size={size}
            value={!!valueGetter ? valueGetter(entity, name) : entity[name]}
            onChange={changeHandlerWrapper}
            style={{
                paddingLeft: !indentAttr ? 0 : `${entity[indentAttr] * 20}px`
            }}
        />
    )
}

export default TextInput
